/**
 * The sidebar's numbers (spec §2). Refetched on an interval, and on realtime frames that move a
 * conversation or a task (`keysForFrame` names the key). A key the server did not answer for is
 * simply absent, and its row shows no number.
 */
import { useQuery } from "@tanstack/react-query";

import { navApi, type NavCounts } from "@/api/nav";
import { queryKeys } from "@/api/queryKeys";

/** One minute: a count that lags a minute is fine; the realtime frame usually lands first. */
const REFRESH_MS = 60_000;

export function useNavCounts(): NavCounts {
  const counts = useQuery({
    queryKey: queryKeys.nav.counts(),
    queryFn: navApi.counts,
    refetchInterval: REFRESH_MS,
  });
  return counts.data ?? {};
}
